import React from "react";
import {Image} from "react-bootstrap";

export const SubgRssiOkayLpx = -90;
export const SubgRssiGreatLpx = -89;
export const SubgRssiExcellentLpx = -78;

export const SubgRssiOkayT10 = -100;
export const SubgRssiGreatT10 = -60;
export const SubgRssiExcellentT10 = -30;

function SignalSymbol ({ sigStrength, isT10 }) {

    const getSymbol = () => {
        if (sigStrength === 0 || sigStrength === null) {
            return (
                <Image src={require('../../img/wifi-weak.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
            );
        }

        if (isT10) {
            if (sigStrength > SubgRssiExcellentT10) {
                return (
                    <Image src={require('../../img/wifi-excellent.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            } else if (sigStrength >= SubgRssiGreatT10) {
                return (
                    <Image src={require('../../img/wifi-great.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            } else if (sigStrength >= SubgRssiOkayT10) {
                return (
                    <Image src={require('../../img/wifi-okay.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            } else {
                return (
                    <Image src={require('../../img/wifi-weak.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            }
        } else {
            if (sigStrength > SubgRssiExcellentLpx) {
                return (
                    <Image src={require('../../img/wifi-excellent.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            } else if (sigStrength >= SubgRssiGreatLpx) {
                return (
                    <Image src={require('../../img/wifi-great.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            } else if (sigStrength >= SubgRssiOkayLpx) {
                return (
                    <Image src={require('../../img/wifi-okay.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            } else {
                return (
                    <Image src={require('../../img/wifi-weak.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
                );
            }
        }
    };

    return (
        getSymbol()
    )
}

export default SignalSymbol;